import { render, staticRenderFns } from "./genre.vue?vue&type=template&id=172d3f7a&scoped=true&"
import script from "./genre.vue?vue&type=script&lang=ts&"
export * from "./genre.vue?vue&type=script&lang=ts&"
import style0 from "./genre.vue?vue&type=style&index=0&id=172d3f7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d3f7a",
  null
  
)

export default component.exports